import React, { useState, useEffect } from "react";
import { Card, Table, Form } from "react-bootstrap";
import scope1Data from "./ESGco2calc_scope1.json";
import scope2Data from "./ESGco2calc_scope2.json";
import scope3Data from "./ESGco2calc_scope3.json";

function ESGco2calc({
  scope1Inputs,
  setScope1Inputs,
  scope2Inputs,
  setScope2Inputs,
  scope3Inputs,
  setScope3Inputs,
}) {
  const [activeScope, setActiveScope] = useState(null);
  const [filteredScope3Data, setFilteredScope3Data] = useState([]);

  useEffect(() => {
    // Get ESGtype from localStorage
    const ESGtype = localStorage.getItem("ESGtype");

    // Filter scope3Data based on ESGtype
    if (ESGtype) {
      const filteredData = scope3Data.filter(
        (item) => item.pk == ESGtype || item.pk == 0
      );
      setFilteredScope3Data(filteredData);
    } else {
      setFilteredScope3Data([]); // Default empty if no ESGtype
    }
  }, []);

  const calculateOutput = (input, formula) => {
    if (!input || !formula) return 0;
    try {
      return eval(formula.replace(/x/g, input));
    } catch (e) {
      console.error("Error in calculation formula: ", e);
      return 0;
    }
  };

  const calculateTotal = (inputs, data) => {
    return data.reduce((sum, item) => {
      const value = calculateOutput(inputs[item.id], item.formula);
      return sum + (isNaN(value) ? 0 : parseFloat(value));
    }, 0);
  };

  const renderTable = (data, inputs, setInputs) => (
    <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th> </th>
          <th>입력</th>
          <th>출력</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr key={item.id}>
            <td>{item.type}</td>
            <td>
              <Form.Control
                type="number"
                value={inputs[item.id] || ""}
                onChange={(e) =>
                  setInputs((prev) => ({ ...prev, [item.id]: e.target.value }))
                }
              />
            </td>
            <td>{calculateOutput(inputs[item.id], item.formula)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  const totalScope1 = calculateTotal(scope1Inputs, scope1Data);
  const totalScope2 = calculateTotal(scope2Inputs, scope2Data);
  const totalScope3 = calculateTotal(scope3Inputs, filteredScope3Data);

  return (
    <div>
      <Card style={{ marginBottom: "10px" }}>
        <Card.Header
          onClick={() =>
            setActiveScope(activeScope === "scope1" ? null : "scope1")
          }
          style={{ cursor: "pointer" }}
        >
          Scope 1 ({totalScope1})
        </Card.Header>
        {activeScope === "scope1" && (
          <Card.Body>
            {renderTable(scope1Data, scope1Inputs, setScope1Inputs)}
          </Card.Body>
        )}
      </Card>

      <Card style={{ marginBottom: "10px" }}>
        <Card.Header
          onClick={() =>
            setActiveScope(activeScope === "scope2" ? null : "scope2")
          }
          style={{ cursor: "pointer" }}
        >
          Scope 2 ({totalScope2})
        </Card.Header>
        {activeScope === "scope2" && (
          <Card.Body>
            {renderTable(scope2Data, scope2Inputs, setScope2Inputs)}
          </Card.Body>
        )}
      </Card>

      <Card style={{ marginBottom: "10px" }}>
        <Card.Header
          onClick={() =>
            setActiveScope(activeScope === "scope3" ? null : "scope3")
          }
          style={{ cursor: "pointer" }}
        >
          Scope 3 ({totalScope3})
        </Card.Header>
        {activeScope === "scope3" && (
          <Card.Body>
            {renderTable(filteredScope3Data, scope3Inputs, setScope3Inputs)}
          </Card.Body>
        )}
      </Card>
    </div>
  );
}

export default ESGco2calc;
